import classNames from "classnames";
import { costFilterList } from "../../_helpers/cost-filter-data";

export const CostFilter = ({ handleFilter, shown, cancelFilter }) => {
    const filterCosts = (a, b) => {
        handleFilter(a, b)
    }
    return (
        <div
            className={classNames(
                "cost-filter-container",
                { "show-cost-filter": shown }
            )}
        >
            <button
                className="cost-filter-unit tr-btn"
                onClick={cancelFilter}
            >
                All costs/Tous les prix
            </button>
            {costFilterList.map((item) => {
                return (
                    <button
                        className="cost-filter-unit tr-btn"
                        onClick={() => filterCosts(item.min, item.max)}
                    >
                        {item.label}
                    </button>
                )
            })}
        </div>
    );
}